<!-- 核查记录 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn search-picker">
            <div class="search-ctn-left">
                <div class="search-name">仓库</div>
                <el-select
                    v-model="searchData.WarehouseId"
                    @visible-change="getWarehouse"
                    :loading="loading"
                    class="search-item"
                    size="small"
                    filterable
                    clearable
                    remote
                    @change="warehouseChange($event)"
                    style="width: 120px"
                >
                    <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"></el-option>
                </el-select>
                <div class="search-name">仓位</div>
                <el-select
                    v-model="shelfSpaceId"
                    :loading="loading"
                    class="search-item"
                    filterable
                    clearable
                    remote
                    multiple
                    collapse-tags
                    reserve-keyword
                    :remote-method="searchPosition"
                    @change="positionChange($event)"
                    size="small"
                    style="width: 180px"
                >
                    <el-option v-for="optionItem in positionList" :key="optionItem.ShelfSpaceId" :label="optionItem.ShelfSpaceCode" :value="optionItem.ShelfSpaceId"></el-option>
                </el-select>
                <div class="search-name">核查人</div>
                <el-select
                    v-model="searchData.StaffId"
                    class="search-item"
                    filterable
                    clearable
                    remote
                    size="small"
                    placeholder="请选择"
                    @visible-change="siVisibleChange($event)"
                    style="width: 180px"
                >
                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <div class="search-name">核查时间</div>
                <el-date-picker
                    v-model="datetime"
                    size="small"
                    class="search-name"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="onDateTimeSelect"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" icon="el-icon-document"  class="search-btn btn-primary" @click="showCheckOrders">核查商品明细</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" @cell-dblclick="handleDBClick">
                <el-table-column show-overflow-tooltip width="180px" prop="WarehouseName" label="核查仓库"></el-table-column>
                <el-table-column show-overflow-tooltip width="180px" prop="SpaceCode" label="核查仓位"></el-table-column>
                <el-table-column show-overflow-tooltip width="130px" prop="CheckType" label="核查类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.CheckType == '整仓核查'">
                            {{ scope.row.CheckType }}
                        </span>
                        <span v-else style="color: #e6a23c"> {{ scope.row.CheckType }} </span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="CheckCount" label="核查项数"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="CheckLabels" label="核查标签数"></el-table-column>
                <el-table-column show-overflow-tooltip width="120px" prop="Checker" label="核查人"></el-table-column>
                <el-table-column show-overflow-tooltip width="180px" prop="CheckTime" label="核查时间"></el-table-column>
                <el-table-column show-overflow-tooltip width="140px" label="是否创建盘点">
                    <template slot-scope="scope">
                        <span v-if="scope.row.IsCreateInven" style="color: red"> 是 </span>
                        <span v-else> - </span></template
                    >
                </el-table-column>
                <el-table-column show-overflow-tooltip width="250px" label="盘点单">
                    <template slot-scope="scope">
                        <div v-if="scope.row.IsCreateInven && scope.row.InvensState != 4" style="color: #409eff" @click="gotoInvenDetails(scope.row)" type="text">
                            {{ scope.row.InvensCode }} {{ scope.row.InvensState == 3 ? '(已归档)' : '' }}
                        </div>
                        <span v-else-if="scope.row.IsCreateInven && scope.row.InvensState == 4" style="color: #b4b4b4"> {{ scope.row.InvensCode }} (已删除)</span>
                        <span v-else> - </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="130px">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.checkLabels && scope.row.CheckLabels > 0" title="查看核查相关的标签" size="mini" style="color: orange" type="text" @click="showLabelDetails(scope.row)">查看核查标签</el-button>                          
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.Page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.Limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="核查商品明细" :visible.sync="checkOrderVisible" width="1300px">
            <div class="dialog-content" v-if="checkOrderVisible">
                <checkOrderDetails ref="checkOrderDetails"></checkOrderDetails>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="核查记录详情" :visible.sync="checkDetailVisible" width="1100px">
            <div class="dialog-content" v-if="checkDetailVisible">
                <inventoryCheckDetail ref="inventoryCheckDetail" :CheckId="checkId"></inventoryCheckDetail>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="查看核查标签" :visible.sync="showLabelsDialog" width="1200px"
            append-to-body>
            <div class="dialog-content" v-if="showLabelsDialog">
                <checkGoodsLabels @closeDialog="closeLabelsDialog" :CheckOId="checkOId"></checkGoodsLabels>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import inventoryCheckDetail from '@/components/business/goods/inventoryCheckDetail';
import checkOrderDetails from '@/components/business/goods/checkOrderDetails';
import checkGoodsLabels from '@/components/business/goods/checkOrderLabels.vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        inventoryCheckDetail,
        checkOrderDetails,
        checkGoodsLabels
    },
    data() {
        return {
            datetime: [],
            WarehouseIdEdit: '',
            loading: false,
            warehouseList: [],
            positionList: [],
            SIdList: [],
            checkOId: '',
            showLabelsDialog: false,
            searchData: {
                WarehouseId: '',
                SpaceIds: '',
                StaffId: '',
                StartDate: '',
                EndDate: '',
                Page: 1,
                Limit: this.commonPageSize
            },
            tableData: [],
            tableDataLength: 0,
            shelfSpaceId: [],
            permission: {},
            checkDetailVisible: false,
            checkOrderVisible:false,
            checkId: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('inventory');
        this.getTableData();
    },
    methods: {
        // 删除
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该调仓吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpTransferOrder/NewDeleteEnterpriseTransferOrder',
                            data: {
                                ToId: row.TOId
                            }
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCheckOrder/CheckRecordsList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length <= 1) {
                    that.$util.getSIdList(false).then(data => {
                        that.SIdList = data;
                    });
                }
            }
        },
        // 仓位改变
        positionChange(value) {
            this.searchData.SpaceIds = value.join(',');
        },
        // 仓库改变
        warehouseChange(value) {
            this.WarehouseIdEdit = value;
            this.shelfSpaceId = [];
            this.searchPosition();
        },
        // 搜仓位
        searchPosition(key) {
            this.loading = true;
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpShelfSpaces/GetEntpeGoodsLocationList',
                        data: {
                            WarehouseId: this.WarehouseIdEdit,
                            ShelfSpaceCode: key,
                            Limit: this.Limit
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        if (res.data) {
                            this.positionList = res.data;
                        } else {
                            this.$util.warningMsg('该仓库暂无仓位');
                        }
                        resolve();
                    })
                    .catch(error => {});
            });
        },
        // 获取仓库列表
        getWarehouse() {
            if(this.warehouseList.length == 0){
                this.$util.getWarehouse().then(data => {
                    this.warehouseList = data;
                });
            }
        },
        resetSearch() {
            this.searchData = {
                EntpId: this.searchData.EntpId,
                WarehouseId: '',
                SpaceIds: '',
                StaffId: '',
                StartDate: '',
                EndDate: '',
                Page: 1,
                Limit: this.commonPageSize
            };
            this.positionList = [];
            this.shelfSpaceId = [];
            this.datetime = [];
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        handleDBClick(event) {
            if (event) {
                this.checkId = event.Id;
                this.checkDetailVisible = true;
            }
        },
        gotoInvenDetails(row) {
            if (row && row.InvensState != 4) {
                let InvensId = row.InvensId;
                this.$router.push(`/inventoryManage/checkInventory/edit?type=1&InvensId=${InvensId}`);
            }
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        showCheckOrders(){
            this.checkOrderVisible = true;
        },
        //关闭订单弹出层
        closeLabelsDialog() {
            this.checkOId = '';
            this.showLabelsDialog = false;
        },
        // 打印
        showLabelDetails(row) {
            if (row) {
                this.checkOId = row.Id;
                this.showLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择核查记录进行查看');
                return;
            }
        },
    }
};
</script>
